/**
 * @class
 * @memberOf P3.tracking
 */
export default class Tracking {
    /**
     * @param {TrackingModule} module
     */
    constructor(module) {
        this._module = module;
    }

    /**
     * @param {TrackingData} data
     */
    track(data) {
        this._module.track(data);
        Tracking.DEBUG && console.log("Track -", data);
    }
}

/**
 * @type {boolean}
 * @static
 */
Tracking.DEBUG = false;